module.exports = __webpack_public_path__ + "static/media/plantD.85c597d6.png";